import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonInfiniteScroll } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/services/http.service';
import { StorageService } from 'src/app/services/storage.service';
import { UiServices } from 'src/app/services/ui-services';
import { InfoProductComponent } from '../info-product/info-product.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit {
  @Input() list: any[] = [];
  @Output() doSearch = new EventEmitter();
  @Output() clearPage = new EventEmitter();
  @ViewChild('inifiniteScroll') inifiniteScroll: IonInfiniteScroll;

  rolId: number = 0;
  oldLength: number = 0;
  options = {
    slidesPerView: 'auto',
    freeMode: false
  }

  constructor(
    private uiSv: UiServices,
    private storageSv: StorageService,
    private httpSv: HttpService,
    private trSv: TranslateService
  ) { }

  async ngOnInit() {
    this.oldLength = this.list.length;
    const { user } = await this.storageSv.get('userInfo');
    this.rolId = user.rol_id;
    this.doSearch.emit();

  }

  async loadData(){
    
    if(this.oldLength < this.list.length){
      this.doSearch.emit();
      await this.inifiniteScroll.complete();
    }else{
      await this.inifiniteScroll.complete();
    }
    this.oldLength = this.list.length;
  }

  async showProducts(products){
    await this.uiSv.showModal(InfoProductComponent, { products }, 'modalAdmin', true)
  }

  async aproveOrder(order){
    try{
      const tr = this.trSv.instant('CONTINUAR_CON_LA_ENTREGA');
      const { role } = await this.uiSv.presentAlert(tr);
      if(role === 'accept'){
        const orderId = order.id
        const res: any = await this.httpSv.itemAction({id: orderId}, 'order', 'delivered');
        order.isDelivered = res.data.isDelivered;
      }
    }catch(err){
      console.error(err);
      
    }
  }

  ngOnDestroy(): void {
    this.clearPage.emit()
  }
}
